module.exports = __webpack_public_path__ + "static/media/foodshot32.cc93b4b1.JPG";